import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../redux-toolkit/hooks";
import { resetAuthState } from "../../redux-toolkit/slices/authSlice";
import { toast } from "react-toastify";
import { useLogoutUserMutation } from "../../redux-toolkit/services/authService";

type Props = {};
const Logout = (props: Props) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [logoutUser, { isSuccess, isError, error }] = useLogoutUserMutation();

    useEffect(() => {
        logoutUser({});
    }, [logoutUser]);

    useEffect(() => {
        if (isSuccess) {
            localStorage.clear();
            dispatch(resetAuthState());
            navigate("/", { replace: true });
            toast.success("Logout Successful");
        } else if (isError) {
            toast.error("Logout Failed");
            localStorage.clear();
            dispatch(resetAuthState());
            navigate("/", { replace: true });
        }
    }, [isSuccess, isError, error, dispatch, navigate]);

    return <div></div>;
};
export default Logout;
